module.exports = __webpack_public_path__ + "static/media/goals-and-targets-revenues.004e48fc.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/goals-and-targets-revenues.mp4
// module id = 555
// module chunks = 0